import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import {TicketTypes} from '../../constants/AppConstants';
import Search from '../../records/Search';
import TrackingActions from "../../actions/TrackingActions";

import PureRenderComponent from '../PureRenderComponent';
import Checkbox from '../form/Checkbox';
import HelpIcon from '../general/HelpIcon';
import FeatureFlag from '../general/FeatureFlag';

class OpenReturnCheckbox extends PureRenderComponent {

    static propTypes = {
        search: PropTypes.instanceOf(Search),
        onChange: PropTypes.func,
        ticketTypeWhenOff: PropTypes.oneOf(Object.values(TicketTypes))
    }

    static defaultProps = {
        search: new Search(),
        onChange: _.noop,
        ticketTypeWhenOff: TicketTypes.SINGLE
    }

    toggleOpenReturn = () => {
        TrackingActions.widgetSearchClick({ name: `open-return:${!this.props.search.isOpenReturn()}` });
        const { search, ticketTypeWhenOff } = this.props;
        const ticketType = search.isOpenReturn() ? ticketTypeWhenOff : TicketTypes.OPEN_RETURN;
        this.props.onChange(search.setTicketType(ticketType));
    }

    render () {
        const label = (
            <span>
                { t('booking.ticketType.openReturn') }
                <FeatureFlag name="enableOpenReturnInfoModal">
                    <HelpIcon
                        icon={ 'info' }
                        heading={ t('help.openReturn.title') }
                        message={ t('help.openReturn.message') }
                    />
                </FeatureFlag>
            </span>
        );

        return (
            <Checkbox label={ label }
                    groupClassName="form-group open-return"
                    checked={ this.props.search.isOpenReturn() }
                    onChange={ this.toggleOpenReturn }/>
        );
    }
}

export default OpenReturnCheckbox;



// WEBPACK FOOTER //
// ./src/components/search/OpenReturnCheckbox.js